// extracted by mini-css-extract-plugin
export var active = "_jg-2";
export var recordingDot = "_jg-1";
export var recordingIndicator = "_jg-0";